// extracted by mini-css-extract-plugin
module.exports = {"Post":"_1o2HMfPPGwQh8jhGPJsml0","profilePic":"_3QrYzGNXnBLwllrGD1TbOe","name":"R7qJpR7V5yrmz2_HHLzSi","title":"_1D-n7FE_WxTfqKueELUPAf","content":"_1Ogz-FC0tYoM2CRDu3XeE0"};